/**
 * @generated SignedSource<<cfb62fdc4796d1db28fe421d047907e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateBitbucketInstallationLinkInput = {
  clientKey: string;
  clientSecret: string;
  oauthScopes?: ReadonlyArray<string> | null | undefined;
};
export type BitbucketIntegrationCreateInstallationLinkMutation$variables = {
  input: CreateBitbucketInstallationLinkInput;
};
export type BitbucketIntegrationCreateInstallationLinkMutation$data = {
  readonly createBitbucketInstallationLink: {
    readonly installationLink: string;
  };
};
export type BitbucketIntegrationCreateInstallationLinkMutation = {
  response: BitbucketIntegrationCreateInstallationLinkMutation$data;
  variables: BitbucketIntegrationCreateInstallationLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBitbucketInstallationLinkPayload",
    "kind": "LinkedField",
    "name": "createBitbucketInstallationLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "installationLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BitbucketIntegrationCreateInstallationLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BitbucketIntegrationCreateInstallationLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1dfe3b95a78f13a0f18f59d969dabd33",
    "id": null,
    "metadata": {},
    "name": "BitbucketIntegrationCreateInstallationLinkMutation",
    "operationKind": "mutation",
    "text": "mutation BitbucketIntegrationCreateInstallationLinkMutation(\n  $input: CreateBitbucketInstallationLinkInput!\n) {\n  createBitbucketInstallationLink(input: $input) {\n    installationLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f4c3b3f456e53582c84a65c0ef74e5d";

export default node;
